import { Outlet } from "react-router-dom";
import { Header } from "../header/Header";
import HelpingWindow from "../helping/HelpingWindow";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import Sidebar from "../sidebar/Sidebar";
import { classNames } from "primereact/utils";

// Компонент - отображается после успешной авторизации на сайте
export function LayoutAfterLoginApp() {
    // определение состояния основного компонента (в зависимости от состояния бокового меню)
    const sidebarIsShown = useAppSelector(state => state.sidebar.sidebarIsShown)

    const mainContentClassnames = classNames({
        "main-content-div": true,
        "full-w": !sidebarIsShown
    })

    return (
        <>
            {/* модальное окно вкладки "Оставить сообщение" */}
            <HelpingWindow />
            {/* главная шапка страницы */}
            <Header type="default" />
            <div className="main-app-div">
                {/* боковое меню */}
                {sidebarIsShown && <Sidebar />}
                {/* основное окно страницы (содержит контент) */}
                <div className={mainContentClassnames}>
                    <Outlet />
                </div>
            </div>
        </>
    )
}